// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__1D2t0","content":"styles_content__2vX84","contentType":"styles_contentType__3ppG0"};